import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SCConfig } from '../../sc-config/constant/sc-config.constant';
import { Filter, GqlWatchResponse } from '../../shared/models/common.model';
import { GqlQueryCommandService } from '../../shared/services/gql-query-command.service';
import { EmailConversation } from '../../app-mail-box/model/email-conversation.model';
import { IpexCommandResponse } from '../../shared/models/responseModels/IpexCommandResponse';
import { ServiceItemTotalPriceMismatchReasons } from '../../shared/models/domain/ServiceItemTotalPriceMismatchReason';
import { QueryHandlerResponse } from '../../shared/models/responseModels/QueryHandlerResponse';
import { UrlResolverService } from '../../shared/services/url/url-resolver.service';

@Injectable({
    providedIn: 'root'
})
export class CaseCreateService {
    private readonly urlResolver = inject(UrlResolverService);
    reopenClosedCaseUrl = `${this.urlResolver.getPcxCommandUrl()}ReopenCase`;
    processQualityCheckStatusUrl = `${this.urlResolver.getPcxCommandUrl()}ProcessQualityCheckStatus`;
    header: any = new HttpHeaders({
        'Content-Type': 'application/json'
    });

    private readonly commonOptions: any = { headers: this.header, withCredentials: true, observe: 'response' };

    constructor(private readonly http: HttpClient, private readonly gqlQueryCommandService: GqlQueryCommandService) {}

    reopenClosedCase(InsuranceCaseId, CaseReopenActionType, notificationSubscriptionId): Observable<any> {
        const payload = {
            InsuranceCaseId,
            CaseReopenActionType
        };
        return this.http
            .post(this.reopenClosedCaseUrl, payload, {
                headers: this.header,
                withCredentials: true,
                observe: 'response'
            })
            .pipe(
                map((response: any) => {
                    return response;
                })
            );
    }
    updateQualityCheck(data): Observable<IpexCommandResponse<any>> {
        return this.http.post<IpexCommandResponse<any>>(this.processQualityCheckStatusUrl, data, {
            headers: this.header,
            withCredentials: true
        });
    }
    getEmailListForCaseConnection(
        departmentId: string,
        pageNo: number,
        connectedEmailIds: any,
        searchKey: string
    ): Observable<GqlWatchResponse<EmailConversation>> {
        const entityName = SCConfig.Entity.EmailConversation;
        const fields = SCConfig.UserReadableDatas.EmailConversation;
        const filters: Filter[] = [];
        if (searchKey) {
            filters.push(
                new Filter(null, 'raw', `$or: [{'From.Name': /${searchKey}/i}, {'Subject': /${searchKey}/i}]`)
            );
        }
        if (departmentId !== null) {
            filters.push(new Filter('DepartmentId', '=', departmentId));
        }
        filters.push(new Filter('_id', 'nin', connectedEmailIds));
        return this.gqlQueryCommandService.gqlWatchQuery<EmailConversation>(
            entityName,
            fields,
            filters,
            'ReceivedDateTime:-1',
            pageNo,
            10
        );
    }

    connectCaseWithEmail(payload) {
        const processCaseUrl = `${this.urlResolver.getPcxCommandUrl()}ConnectCaseWithEmail`;

        return this.http
            .post(processCaseUrl, payload, { headers: this.header, withCredentials: true, observe: 'response' })
            .pipe(
                map((response: any) => {
                    return response.body;
                })
            );
    }
    // setCKEditorFont() {
    //     let iframeElements = document.getElementsByTagName('iframe');
    //     if (iframeElements && iframeElements.length > 0) {
    //         Array.from(iframeElements).forEach(iframe => {
    //             let iframeContentDocument = iframe.contentDocument;
    //             if (
    //                 iframeContentDocument &&
    //                 iframeContentDocument.documentElement &&
    //                 iframeContentDocument.documentElement.style &&
    //                 iframeContentDocument.documentElement.style.fontFamily !== 'system-ui'
    //             ) {
    //                 iframeContentDocument.documentElement.style.fontFamily = 'system-ui';
    //             }
    //         });
    //     }
    // }
    public getServiceSubItemTotalPriceMismatchReason(): Observable<
        QueryHandlerResponse<null, ServiceItemTotalPriceMismatchReasons[]>
    > {
        const payload = {
            SortBy: '',
            FilterString: '{}',
            PageNumber: 1,
            PageSize: 10
        };
        const totalPriceMismatchUrl = `${this.urlResolver.getPcxQueryUrl()}GetServiceItemTotalPriceMismatchReason`;

        return this.http
            .post<QueryHandlerResponse<null, ServiceItemTotalPriceMismatchReasons[]>>(
                totalPriceMismatchUrl,
                payload,
                SCConfig.HttpCommonPostOptions
            )
            .pipe(
                map(element => {
                    if (element?.Results) {
                        element.Results = element.Results.sort((a, b) => {
                            const germanLabelA = a.Label.find(x => x.Key === SCConfig.LanguageKey.German).Value;
                            const germanLabelB = b.Label.find(x => x.Key === SCConfig.LanguageKey.German).Value;
                            if (
                                germanLabelA === SCConfig.PriceMismatchReasonCustomComment.GermanLabel ||
                                germanLabelB === SCConfig.PriceMismatchReasonCustomComment.GermanLabel
                            ) {
                                return 0;
                            }
                            return germanLabelA > germanLabelB ? 1 : -1;
                        });
                    }
                    return element;
                })
            );
    }

    public getCurrentSwissTime() {
        let url = `${this.urlResolver.getPcxQueryUrl()}GetCurrentSwissTime`;
        return this.http.get(url).pipe(
            map((response: any) => {
                return response;
            })
        );
    }
}
